var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bet-zone-container" }, [
    _c(
      "div",
      { staticClass: "bet-zone-bg-wrapper" },
      [
        _c("BetZoneBg", {
          attrs: {
            playerDisabled: _vm.isPlayerDisabled,
            bankerDisabled: _vm.isBankerDisabled,
            drawDisabled: _vm.isDrawDisabled,
          },
          on: {
            bankerClicked: function ($event) {
              return _vm.chipBetHandler("banker")
            },
            drawClicked: function ($event) {
              return _vm.chipBetHandler("draw")
            },
            playerClicked: function ($event) {
              return _vm.chipBetHandler("player")
            },
          },
        }),
        _c("Info"),
        _vm.leftData > 0
          ? _c(
              "div",
              { staticClass: "chip banker-chip" },
              [
                _c(
                  "Chip",
                  { attrs: { chipValue: _vm.leftData, displayOnly: true } },
                  [_c("ChipDisplay", { attrs: { chip: _vm.bankerChip } })],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.betData.draw > 0
          ? _c(
              "div",
              { staticClass: "chip draw-chip" },
              [
                _c(
                  "Chip",
                  { attrs: { chipValue: _vm.betData.draw, displayOnly: true } },
                  [_c("ChipDisplay", { attrs: { chip: _vm.drawChip } })],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.rightData > 0
          ? _c(
              "div",
              { staticClass: "chip player-chip" },
              [
                _c(
                  "Chip",
                  { attrs: { chipValue: _vm.rightData, displayOnly: true } },
                  [_c("ChipDisplay", { attrs: { chip: _vm.playerChip } })],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }